<template>
  <nav class="fixed top-0 left-0 w-full z-50 transition-all duration-300" :class="{ 'bg-slate-900/90 backdrop-blur-md shadow-lg': isScrolled, 'bg-transparent': !isScrolled }">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex items-center justify-between h-20 md:h-24">
        <!-- Logo -->
        <div class="flex-shrink-0">
          <router-link to="/" class="flex items-center gap-2">
            <img src="/img/logo.png" alt="EM Contracting Corp Logo" class="h-16 md:h-20 w-auto object-contain">
          </router-link>
        </div>
        
        <!-- Desktop Menu -->
        <div class="hidden md:block">
          <div class="ml-10 flex items-baseline space-x-8">
            <router-link to="/" class="text-gray-300 hover:text-white hover:bg-slate-800 px-3 py-2 rounded-md text-sm font-medium transition-colors" active-class="text-white bg-slate-800">Home</router-link>
            <router-link to="/about" class="text-gray-300 hover:text-white hover:bg-slate-800 px-3 py-2 rounded-md text-sm font-medium transition-colors" active-class="text-white bg-slate-800">About Us</router-link>
            <router-link to="/services" class="text-gray-300 hover:text-white hover:bg-slate-800 px-3 py-2 rounded-md text-sm font-medium transition-colors" active-class="text-white bg-slate-800">Services</router-link>
            <router-link to="/projects" class="text-gray-300 hover:text-white hover:bg-slate-800 px-3 py-2 rounded-md text-sm font-medium transition-colors" active-class="text-white bg-slate-800">Projects</router-link>
            <router-link to="/contact" class="bg-amber-500 hover:bg-amber-400 text-slate-900 px-4 py-2 rounded-md text-sm font-bold transition-colors">Contact</router-link>
          </div>
        </div>

        <!-- Mobile menu button -->
        <div class="-mr-2 flex md:hidden">
          <button @click="isOpen = !isOpen" type="button" class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white" aria-controls="mobile-menu" aria-expanded="false">
            <span class="sr-only">Open main menu</span>
            <svg v-if="!isOpen" class="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
            <svg v-else class="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- Mobile Menu -->
    <div v-show="isOpen" class="md:hidden bg-slate-900 shadow-xl" id="mobile-menu">
      <div class="px-2 pt-2 pb-3 space-y-1 sm:px-3">
        <router-link to="/" @click.native="isOpen = false" class="text-gray-300 hover:text-white block px-3 py-2 rounded-md text-base font-medium" active-class="bg-slate-800 text-white">Home</router-link>
        <router-link to="/about" @click.native="isOpen = false" class="text-gray-300 hover:text-white block px-3 py-2 rounded-md text-base font-medium" active-class="bg-slate-800 text-white">About Us</router-link>
        <router-link to="/services" @click.native="isOpen = false" class="text-gray-300 hover:text-white block px-3 py-2 rounded-md text-base font-medium" active-class="bg-slate-800 text-white">Services</router-link>
        <router-link to="/projects" @click.native="isOpen = false" class="text-gray-300 hover:text-white block px-3 py-2 rounded-md text-base font-medium" active-class="bg-slate-800 text-white">Projects</router-link>
        <router-link to="/contact" @click.native="isOpen = false" class="text-amber-500 font-bold block px-3 py-2 rounded-md text-base">Contact</router-link>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Navbar',
  data() {
    return {
      isOpen: false,
      isScrolled: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 20
    }
  }
}
</script>
